/**
 * Величины тулбаров редактора, общие для самих тулбаров и их скелетонов
 * (`ui/components/skeletons/editor-toolbar-skeletons.tsx`). Живут отдельно от
 * тулбаров, чтобы скелетон не тянул за собой их зависимости (fabric, иконки).
 */

/** Ширина левого тулбара. Скелетон той же ширины — канва не сдвигается при появлении тулбара. */
export const EDITOR_LEFT_TOOLBAR_WIDTH = 52;

/**
 * Кнопки левого тулбара по группам между разделителями: «Текст, Фигуры» | плейсхолдеры |
 * «Блоки макета» | отмена/повтор | масштаб | сетка | «Дублировать, Группа, Удалить, Горячие
 * клавиши». По ней рисует скелетон; добавляя кнопку в `editor-left-toolbar.tsx`, поправьте и эту
 * строку — тест скелетона сверяет число кнопок с настоящим тулбаром.
 */
export const EDITOR_LEFT_TOOLBAR_GROUPS: readonly number[] = [2, 2, 1, 2, 3, 2, 4];

/** Ширина правого тулбара (инспектора). */
export const EDITOR_RIGHT_TOOLBAR_WIDTH = 308;
